<template>
  <div class="zangyou-mikomi edit-item" v-if="editingData">

    <div class="head"><b>残業（見込み）</b></div>
    <div class="data flex flex-align-center">
      <div class="kingaku">
        <input-text v-model="editingData.zangyou_mikomi" :type="'number'" inputmode="numeric" class="medium" min="0"
          :error="getError(editingData, 'zangyou_mikomi')" :disabled="disabled"></input-text>
        <p class="current-data" v-if="currentData">{{ numberFormat(currentData.zangyou_mikomi) }}</p>
      </div>
      <p class="scale">円</p>
    </div>

  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { numberFormat } from '@/filters/common';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();

    return {
      getError,
      numberFormat
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
